export default "/_next/static/fonts/IntercomBrand-Medium-3e0e26b7d9fae8c9827502b18c11841b.woff2";